<template>
    <ais-instant-search
        :search-client="searchClient"
        index-name="search"
        :routing="routing"
        class="h-full w-full"
    >
        <ais-configure :hits-per-page.camel="5" />
        <Autocomplete />
    </ais-instant-search>
</template>

<script>
import { ref } from '@vue/composition-api';
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import Autocomplete from './Autocomplete.vue';

const algoliaClient = algoliasearch(window.algoliaApplicationId, window.algoliaSearchApiKey);

export default {
    components: {
        Autocomplete
    },

    setup() {
        const routing = ref({
            router: historyRouter(),
            stateMapping: singleIndexMapping('search')
        });

        const searchClient = {
            ...algoliaClient,
            search(requests) {
                if (requests.every(({ params }) => !params.query)) {
                    return Promise.resolve({
                        results: requests.map(() => ({
                            hits: [],
                            nbHits: 0,
                            nbPages: 0,
                            page: 0,
                            processingTimeMS: 0,
                            hitsPerPage: 0,
                            exhaustiveNbHits: false,
                            query: '',
                            params: ''
                        }))
                    });
                }

                return algoliaClient.search(requests);
            }
        };

        return {
            searchClient,
            routing
        };
    }
};
</script>
